import React, { useCallback, useMemo, useState, useEffect } from 'react'
import styled from 'styled-components'
import { BigNumber } from 'bignumber.js'

import { stopPropagation } from '../../../utils/func'
import useModal from '../../../hooks/bakery/useModal'
import useBid from '../../../hooks/nft/useBidding'
import useMaxBidPrice from '../../../hooks/nft/useMaxBidPrice'
import useUpdateBid from '../../../hooks/nft/useUpdateBid'
import useSellTokenTo from '../../../hooks/nft/useSellTokenTo'

import { ButtonConfirmed } from '../../Button'
import BiddingModal from '../../../pages/Artworks/components/BiddingModal'
import { userTokenDecimals } from '../../../userType/userTokenDecimals'

import useUserBids from '../../../hooks/nft/useUserBids'
import { userTokenName } from '../../../userType/userTokenName'
import useYam from '../../../hooks/bakery/useYam'
import { useActiveWeb3React } from '../../../hooks'
// import { useMarketLevel } from '../../../state/market/hooks'

const Button = styled(ButtonConfirmed)<{bg?: string, color?: string}>`
  border: none;
  font-size: 14px;
  width: 244px;
  height: 40px;
  border-radius: 10px;
  padding: 0;
  background: ${({bg, theme}) => (bg ? bg : theme.bsBg4)};
  color: ${({color, theme}) => (color ? color : theme.primaryText1)};
  &:hover{
    background: ${({bg, theme}) => (bg ? bg : theme.bsBg4)};
    color: ${({color, theme}) => (color ? color : theme.primaryText1)};
  }
`

export default function OfferMadeBtn (
  {
    ids, aksIds, 
    artwork, isMyArtwork,
    marketType, symbol
  }: 
  {
    ids: any, aksIds: any, 
    artwork: any, isMyArtwork?: boolean,
    marketType: string, symbol: string
  }) {
  // const theme = useContext(ThemeContext)

  // 竞价单重新获取币种
  const [resetSymbol, setResetSymbol] = useState(symbol)

  // 获取我的竞价
  // const level = useMarketLevel()
  const { account } = useActiveWeb3React()
  const sushi = useYam()
  const getMyBids = useUserBids(marketType)
  const getMyIds = useCallback(async() => {
    const myBids = await getMyBids()
    if (myBids.length) {
      // eslint-disable-next-line array-callback-return
      myBids.map((d: any) => {
        if(d[0] + '-' + d[3] === artwork.nftId + '-' + artwork.nftType){
          let symbolReset = userTokenName(sushi, d[2])
          setResetSymbol(symbolReset)
        }
      })
    }
  }, [getMyBids, artwork, sushi])

  useEffect(() => {
    if (account) {
      getMyIds()
    }
  }, [getMyIds, getMyBids, account, artwork])

  let decimals = userTokenDecimals(symbol)

  const isAuction = artwork.auctionPrice
  const handBid = ((event: any) => {
    stopPropagation(event)
    if(artwork.level === 'v3'){
      openModal()
    }
  })

  const {onBid} = useBid(artwork.tokenId, marketType, symbol) 
  const {onMaxBidPrice} = useMaxBidPrice(artwork.tokenId, artwork.nftType)
  const {onUpdate} = useUpdateBid(artwork.tokenId, marketType, artwork.auctionPrice ? onMaxBidPrice : '', resetSymbol)
  const handleBid = useCallback(async (amount: string) => {
    try {
      const txHash = await onBid(amount)
      txHash && artwork.auctionPrice && await onMaxBidPrice(new BigNumber(amount).div(new BigNumber(10).pow(decimals)).toString())
      if (txHash) {
        console.log('txHash', txHash)
      }
    } catch (e) {
      console.log(e)
    }
  }, [onBid, artwork, onMaxBidPrice, decimals])

  // 将token卖给指定地址
  const {onSellBid} = useSellTokenTo(artwork.tokenId, marketType, symbol)
  const onSellTokenTo = useCallback(async (address: string, price?: any) => {
    try {
      const txHash = await onSellBid(address, price)
      console.log('txHash', txHash)
    } catch (e) {
      console.log(e)
    }
  }, [onSellBid])

  const tokenId = useMemo(() => {
    return artwork.tokenId
  }, [artwork])

  const [openModal] = useModal(
    <BiddingModal
      onSellTokenTo={onSellTokenTo}
      onConfirm={ 
        ids.includes(tokenId as never)
        ? onUpdate
        : aksIds.includes(tokenId as never)
        ? () => {}
        : handleBid
      }
      name={artwork.name}
      isBidding={!aksIds.includes(tokenId as never)}
      artist={artwork.author}
      tokenId={artwork.tokenId}
      type={marketType}
      auctionPrice={artwork.auctionPrice}
      tokenName={symbol}
   />,
  )

  return (
      <>
        {
          isAuction && !isMyArtwork ?
          <Button
            onClick={handBid}
            disabled={resetSymbol !== symbol}
            altDisabledStyle={resetSymbol !== symbol}
            bg={artwork.level ==='v3' ||  isMyArtwork ? '' : '#C4C4C4'}
            color={artwork.level ==='v3' ||  isMyArtwork ? '' : '#DEDEDE'}
            style={{
              width: '100%'
            }}
          >
            { ids.includes(tokenId as never) && isMyArtwork ? 'update' : 'Bidding'}
          </Button>
          :
          <Button
            onClick={handBid}
            disabled={resetSymbol !== symbol}
            altDisabledStyle={resetSymbol !== symbol}
            bg={artwork.level ==='v3' ||  isMyArtwork ? '' : '#C4C4C4'}
            color={artwork.level ==='v3' ||  isMyArtwork ? '' : '#DEDEDE'}
            style={{
              marginRight: '16px',
              // background: artwork.tokenName && symbol !== artwork.tokenName ? theme.bg3 : theme.bg1,
              // border: `1px solid ${theme.bsText7}`,
              // color: theme.bsText7
            }}
          >
            { ids.includes(tokenId as never) && isMyArtwork ? 'update' : 'Bidding'}
          </Button>
        }
      </>
  )
    
}